
const _USERNAMES = ['陈志坚', '马珺玉', '何立君「海外」','何立君「国内」', '冯梦姣', '蓝豪']; // 负责人名单
const _PROVIDERTYPES = ["电台", "公众号", "B站", "微博", "电台主持人", "Youtube"]; // 按类型查看时 Table
const _EXTRAPROVIDERTYPES = ["抖音"]; // 额外的类型， 不出现在按类型查看中
const _BROKERS = ['冯梦姣', '蓝豪']; // 按对接人获取

const _USERTYPES = { // 按负责人查看时展示子项
  '陈志坚': ['新客', '续约'],
  '马珺玉': ['老客'],
  '何立君「海外」': ['老客'],
  '何立君「国内」': ['老客'],
  '冯梦姣': ['新客', '续约'],
  '蓝豪': ['新客', '续约'],
}
const _INCHARGETYPES = { // 负责人分管渠道
  '陈志坚': ['电台', '电台主持人'],
  '马珺玉': ['电台', '电台主持人'],
  '何立君「国内」': ["公众号", "B站", "微博", "抖音"],
  '何立君「海外」': ["Youtube"],
}
/**另注： 对接人只看对接人信息 */
export default class Utils {
  static BROKERS = _BROKERS;
  static USERNAMES = _USERNAMES;
  static USERTYPES = _USERTYPES;
  static INCHARGETYPES = _INCHARGETYPES;
  static PROVIDERTYPES = _PROVIDERTYPES;
  static EXTRAPROVIDERTYPES = _EXTRAPROVIDERTYPES;

  static getTargetProviderTypes = (type) => {
    if (type === 'user') return Utils.USERNAMES
    return ['全部', ...Utils.PROVIDERTYPES]
  }
}